import { useState } from "react";

import { AlertV4, ButtonV4, FieldV4, ModalV4, SelectV4 } from "../common/ui";

import { CANCEL_REASONS } from "./orderAppointmentModelV4";

// Types
type CancelReason = (typeof CANCEL_REASONS)[number];

type ModalCancelOrderAppointmentV4Props = {
  // data
  /** "นัดหมาย 123 · ศุกร์ 30/10/2569 09:00" */
  title: string;
  busy: boolean;
  error?: unknown;
  // callback
  onClose: () => void;
  onConfirm: (reason: CancelReason) => void;
};

// Const
const REASON_OPTIONS = CANCEL_REASONS.map((item) => ({ value: item.text, text: item.text }));

const ModalCancelOrderAppointmentV4 = (props: ModalCancelOrderAppointmentV4Props) => {
  const [reason, setReason] = useState("");

  // Handler
  const handleConfirm = () => {
    const found = CANCEL_REASONS.find((item) => item.text === reason);

    if (found) {
      props.onConfirm(found);
    }
  };

  // Render
  return (
    <ModalV4 title="ยืนยันการยกเลิกนัดหมาย" tone="danger" width={420} onClose={props.onClose}>
      <div className="hv4-ord-ap-hint">{props.title}</div>
      <FieldV4 label="ยกเลิกนัดโดย / เหตุผล *" htmlFor="hv4_ord_ap_cancel">
        <SelectV4
          id="hv4_ord_ap_cancel"
          options={REASON_OPTIONS}
          placeholder="เลือก"
          value={reason}
          onChange={setReason}
        />
      </FieldV4>
      {!!props.error && (
        <AlertV4 tone="danger" error={props.error}>
          ยกเลิกนัดไม่สำเร็จ:{" "}
        </AlertV4>
      )}
      <div className="hv4-ord-ap-modal-foot">
        <ButtonV4 variant="ghost" onClick={props.onClose}>
          ไม่ยกเลิก
        </ButtonV4>
        <ButtonV4 variant="danger" disabled={!reason || props.busy} onClick={handleConfirm}>
          ยืนยันยกเลิกนัด
        </ButtonV4>
      </div>
    </ModalV4>
  );
};

ModalCancelOrderAppointmentV4.displayName = "ModalCancelOrderAppointmentV4";

export default ModalCancelOrderAppointmentV4;
